// /* eslint-disable no-unused-expressions */
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import Loading from "../../../components/shared/loading/Loading";
// import { deleteData } from "../../../hooks/delete";
// import useFetch from "../../../hooks/useFetch";
// import { apiPath, clientSideUrl } from "../../../utility/Constant";
// import WorkforceCard from "./WorkforceCard";

// const WorkforceListPage = () => {
//   const { workforceApi } = apiPath;
//   const { clientServices } = clientSideUrl;
//   const [workforceListData, workforceListLoading] = useFetch(workforceApi);
//   const [filteredData, setFilteredData] = useState();

//   useEffect(() => {
//     setFilteredData(
//       workforceListData?.filter((item) => item.Slug !== "banner")
//     );
//   }, [workforceListData]);

//   if (workforceListLoading) {
//     return <Loading />;
//   }

//   async function handleSingleDelete(id) {
//     const swalResponse = await Swal.fire({
//       title: "Are you sure you want to delete this?",
//       showCancelButton: true,
//       confirmButtonText: "Delete",
//       showLoaderOnConfirm: true,
//       preConfirm: async () => {
//         return await deleteData(workforceApi, id);
//       },
//       allowOutsideClick: () => !Swal.isLoading(),
//     });
//     return swalResponse?.value?._id?.length > 0;
//   }

//   return (
//     <div>
//       <div className="mb-2 w-full text-right font-semibold text-sm">
//         <Link
//           className="text-black hover:text-[#DB0029]"
//           to={clientServices}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           Visit page
//           <span>
//             <svg
//               xmlns="http://www.w3.org/2000/svg"
//               fill="none"
//               viewBox="0 0 24 24"
//               strokeWidth={1.5}
//               stroke="currentColor"
//               className="inline w-4 h-4 ml-1 align-text-top"
//             >
//               <path
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//                 d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
//               />
//             </svg>
//           </span>
//         </Link>
//       </div>
//       <h1 className="font-oswald font-bold text-2xl mt-5 mb-4 uppercase">
//         section info
//       </h1>
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-8">
//         <WorkforceCard />
//         {filteredData?.map((item, idx) => (
//           <WorkforceCard
//             key={idx}
//             project={item}
//             user={"admin"}
//             handleSingleDelete={handleSingleDelete}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default WorkforceListPage;





/* eslint-disable no-unused-expressions */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loading from "../../../components/shared/loading/Loading";
import { deleteData } from "../../../hooks/delete";
import { updateData } from "../../../hooks/update";
import useFetch from "../../../hooks/useFetch";
import { apiPath, clientSideUrl, RoutePath } from "../../../utility/Constant";
import WorkforceCard from "./WorkforceCard";
import { SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { MdDragIndicator } from "react-icons/md";
import { motion } from "framer-motion";

const WorkforceListPage = () => {
  const { workforceApi } = apiPath;
  const { clientServices } = clientSideUrl;
  const [workforceListData, workforceListLoading] = useFetch(workforceApi);
  const [filteredData, setFilteredData] = useState([]);
  const [updatedOrder, setUpdatedOrder] = useState(null);
  const { servicesWorkforceList } = RoutePath
  useEffect(() => {
    const filtered = workforceListData?.filter((item) => item.Slug !== "banner") || [];
    setFilteredData(filtered);
  }, [workforceListData]);

  if (workforceListLoading) {
    return <Loading />;
  }

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(workforceApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?._id?.length > 0;
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMoveImmutable(filteredData, oldIndex, newIndex);
    setFilteredData(newOrder);
    const payload = newOrder.map((item, idx) => ({
      _id: item._id,
      orderId: idx + 1,
    }));
    setUpdatedOrder(payload);
  };

  const updateOrderToDB = () => {
    updateData("reorder/workforce", updatedOrder);
    setTimeout(() => {
      setUpdatedOrder(null);
      window.location.href = "/" + servicesWorkforceList;
    }, 800);
  };

  const DragHandle = SortableHandle(() => (
    <div className="absolute top-1 left-1 z-10 bg-white bg-opacity-80 rounded-full p-1">
      <MdDragIndicator className="text-gray-600 cursor-move" size={20} />
    </div>
  ));

  const SortableItem = SortableElement(({ item }) => (
    <WorkforceCard
      key={item._id}
      project={item}
      user={"admin"}
      handleSingleDelete={handleSingleDelete}
      dragHandle={<DragHandle />}
    />
  ));

  const SortableList = SortableContainer(({ items }) => (
    <div className="select-none grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4 md:gap-8">
      <WorkforceCard /> {/* Add new card */}
      {items.map((item, index) => (
        <SortableItem key={item._id} index={index} item={item} />
      ))}
    </div>
  ));

  return (
    <div>
      <div className="mb-2 w-full text-right font-semibold text-sm">
        <div className="flex justify-end items-center gap-4">
          {updatedOrder && (
            <motion.button
              onClick={updateOrderToDB}
              type="button"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="btn border-2 text-[#DB0029] font-bold border-[#DB0029] hover:text-white hover:bg-[#DB0029] px-3 py-1.5 rounded-xl"
            >
              Save Changes
            </motion.button>
          )}
          <Link
            className="text-black hover:text-[#DB0029]"
            to={clientServices}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit page
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="inline w-4 h-4 ml-1 align-text-top"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                />
              </svg>
            </span>
          </Link>
        </div>
      </div>

      <h1 className="font-oswald font-bold text-2xl mt-5 mb-4 uppercase">
        section info
      </h1>

      <SortableList items={filteredData} onSortEnd={onSortEnd} axis="xy" useDragHandle />
    </div>
  );
};

export default WorkforceListPage;
